import React, { useEffect, useState } from "react";
import { Trash2, Mail, Clock, CheckCircle2 } from "lucide-react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";

const Messages = () => {
  const [items, setItems] = useState(null);
  const refresh = async () => setItems(await adminApi.messages.list());

  useEffect(() => { refresh(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      await adminApi.messages.remove(id);
      toast.success("Deleted");
      refresh();
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="space-y-5">
      <div>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cyan-300 mb-1">CMS</div>
        <h1 className="font-display text-3xl text-white font-medium">Inbox</h1>
        <p className="text-slate-400 text-sm mt-1">Contact-form submissions stored in MongoDB.</p>
      </div>

      {items === null && [0,1,2].map((i) => <div key={i} className="glass rounded-xl h-20 animate-pulse" />)}
      {items !== null && items.length === 0 && (
        <div className="glass rounded-2xl p-10 text-center text-slate-400 text-sm">No messages yet.</div>
      )}
      <div className="space-y-2">
        {items?.map((m) => (
          <div key={m.id} className="glass rounded-xl p-4 flex items-start gap-4">
            <div className="w-9 h-9 rounded-lg border border-white/10 bg-white/[0.03] grid place-items-center shrink-0">
              <Mail size={14} className="text-cyan-300" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-white text-sm font-medium truncate">{m.subject}</div>
              <div className="text-xs text-slate-500 truncate">
                {m.name} &lt;{m.email}&gt; · <Clock size={11} className="inline -mt-0.5" /> {new Date(m.created_at).toLocaleString()}
                {m.email_sent && <span className="ml-2 text-emerald-400 inline-flex items-center gap-1"><CheckCircle2 size={11}/> emailed</span>}
              </div>
              <p className="mt-2 text-sm text-slate-300 whitespace-pre-wrap line-clamp-3">{m.message}</p>
            </div>
            <button onClick={() => remove(m.id)} className="p-2 text-slate-500 hover:text-red-400 rounded-lg hover:bg-white/5" title="Delete">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Messages;
